import { Injectable } from '@angular/core'
import { Select, State, Action, StateContext, Selector, NgxsOnInit, Store, NgxsSimpleChange } from '@ngxs/store'
import { Observable } from 'rxjs';
import { UserState } from 'src/app/state-man/state/user.state';
import { User } from 'src/app/state-man/models/user.model';
import { WorkOrder } from '../models/work-order.model';
import { WorkOrderOpenActions } from '../actions/work-order-open.actions';
import { WorkOrderService } from 'src/app/services/work-order.service';
import { StorageService } from 'src/app/services/storage.service';
import { stateContentChanged } from './state-content-changed'

export class WorkOrderOpenStateModel {
    is_refreshing: boolean
    work_order: WorkOrder[]
}

@State<WorkOrderOpenStateModel>({
    name: 'work_order_open',
    defaults: {
        is_refreshing: true,
        work_order: []
    }
})
@Injectable()
export class WorkOrderOpenState implements NgxsOnInit {
    @Select(UserState.getUser) user$: Observable<User>

    constructor(        
        private workOrderService: WorkOrderService,
        private store: Store,
        private storageService: StorageService
    ) {}

    async ngxsOnInit(ctx: StateContext<WorkOrderOpenStateModel>) {                
        this.user$.subscribe(async (user: User) => {            
            if (user.is_logged_in) {     
                this.storageService.events.subscribe(async (status: any) => {
                    if (this.storageService.is_initialized) {
                        await this.reloadStateFromStorage()                        
                    }
                })                           
            }
        }) 
    }

    async ngxsOnChanges(change: NgxsSimpleChange) {    
        if (this.storageService.is_initialized && stateContentChanged(change)) {
            const state_model: WorkOrderOpenStateModel = change.currentValue
            this.storageService.set('work_orders', JSON.stringify(state_model))    
        }              
    }

    async reloadStateFromStorage() {        
        const json = await this.storageService.get('work_orders');        
        if (json) {
            const state_model: WorkOrderOpenStateModel = JSON.parse(json)
            if (state_model) {
                this.store.dispatch(new WorkOrderOpenActions.Init(state_model));
                return
            }
        }
        this.store.dispatch(new WorkOrderOpenActions.Refresh())
    }

    async reloadStateFromApi() : Promise<boolean> {
        const openWOs = await this.workOrderService.getOpen()
        if (openWOs != null) {
          // The service has already run buildMany over the response, so the
          // rows arriving here are built models. Building them a second time
          // allocated a duplicate object for every row and, where buildOne
          // rebuilds children, re-walked those too.
          this.store.dispatch(new WorkOrderOpenActions.Set(openWOs))
          return true
        }
        return false
    }
  
    @Selector()
    static getState(state: WorkOrderOpenStateModel) {
        return state
    }

    @Selector()
    static getIsRefreshing(state: WorkOrderOpenStateModel) {
        return state.is_refreshing
    }

    @Selector()
    static getOpenAll(state: WorkOrderOpenStateModel) {
        return state.work_order
    }

    @Action(WorkOrderOpenActions.Refresh)
    async refresh({patchState}: StateContext<WorkOrderOpenStateModel>, {  }:WorkOrderOpenActions.Refresh) {
        patchState({is_refreshing: true})
        if (!await this.reloadStateFromApi()) {            
            patchState({is_refreshing: false})
        }
    }

    @Action(WorkOrderOpenActions.Init)
    init({setState, getState}: StateContext<WorkOrderOpenStateModel>, { payload }:WorkOrderOpenActions.Init) {                  
        const state = getState()
        payload.is_refreshing = state.is_refreshing
        setState(payload)
        this.store.dispatch(new WorkOrderOpenActions.Refresh())
    }
    
    @Action(WorkOrderOpenActions.Set)
    set({setState}: StateContext<WorkOrderOpenStateModel>, { payload }:WorkOrderOpenActions.Set) {             
        setState({       
            is_refreshing: false,     
            work_order: payload
        })
    }
}
